import { SupportLayout } from './SupportLayout';

export { SupportLayout };
